import styled from "styled-components";

export default styled.a`
  color: ${(props) => props.theme.primaryColor};
  font-size: 1em;
  cursor: pointer;
`;
